package org.braunequip.web.components.forms.Maintenance

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaX
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.document
import kotlinx.datetime.*
import org.braunequip.web.components.forms.SubmitButton
import org.braunequip.web.components.models.MaintSchedulesDTO
import org.braunequip.web.components.widgets.ConfirmModal
import org.braunequip.web.util.*
import org.braunequip.web.util.Constants.FONT_FAMILY
import org.braunequip.web.util.Constants.FONT_FAMILY2
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.HTMLTextAreaElement
import kotlin.js.Date

@Composable
fun AdminMaintScheduleForm(
    toUpdateMaintSched: MaintSchedulesDTO? = null,
    onSubmit: (MaintSchedulesDTO) -> Unit,
    onDismiss: () -> Unit
) {
    var showConfirmModal by remember { mutableStateOf(false) }
    var errorText by remember { mutableStateOf(" ") }
    var newMaintSched by remember(toUpdateMaintSched) {
        mutableStateOf(
            toUpdateMaintSched?.copy() ?: MaintSchedulesDTO()
        )
    }

    var useMilesInterval by remember { mutableStateOf(toUpdateMaintSched?.intervalMiles != null) }
    var useDaysInterval by remember { mutableStateOf(toUpdateMaintSched?.intervalDays != null) }

    val todayValue: LocalDate = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).date
    val existingDateValue = newMaintSched.startDate?.let { LocalDateTime.parse(it) }?.date
    val startDateValue: String = (existingDateValue ?: todayValue).toString()

    LaunchedEffect(Unit) {
        //Necessary for loading default value, and having it still be editable.
        val assetFormTextArea = (document.getElementById(InputIDs.MaintenanceSchedules.scheduleDescription) as HTMLTextAreaElement)
        assetFormTextArea.value = newMaintSched.description
    }

    Box(
        modifier = Modifier
            .width(100.vw)
            .height(100.vh)
            .position(Position.Absolute)
            .top(0.px)
            .left(0.px)
            .zIndex(19),
        contentAlignment = Alignment.TopCenter
    ) {
        Column(
            modifier = Modifier
                .backgroundColor(Colors.White)
                .borderRadius(20.px)
                .margin(top = 4.cssRem)
                .padding(1.cssRem)
                .zIndex(20)
                .width(min(500.px, 100.percent - 2.cssRem)),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Top
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {

                SpanText(
                    text = if (newMaintSched.id != null) "ID: ${newMaintSched.id}" else "ID: TBD",
                    modifier = Modifier
                        .fontSize(1.cssRem)
                        .fontFamily(FONT_FAMILY2)
                )


                FaX(
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .onClick {
                            onDismiss()
                        }
                        .color(Colors.Grey)
                )
            }

            /* Specific Form Rows Here */
            H3(
                attrs = Modifier
                    .fillMaxWidth()
                    .textAlign(TextAlign.Start)
                    .color(Colors.Black)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(1.cssRem)
                    .fontWeight(FontWeight.Medium)
                    .toAttrs()
            ) {
                Text("Schedule Name:")
            }

            Input(
                type = InputType.Text,
                attrs = Modifier
                    .id(InputIDs.MaintenanceSchedules.scheduleName)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 2.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .toAttrs {
                        attr("value", newMaintSched.name) // Set value from DTO
                    }
            )


            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Input(
                    type = InputType.Checkbox,
                    attrs = Modifier
                        .height(15.px)
                        .width(15.px)
                        .margin(
                            right = 12.px,
                        )
                        .padding(leftRight = 20.px)
                        .backgroundColor(Theme.LightGray.rgb)
                        .borderRadius(r = 4.px)
                        .border(
                            width = 1.px,
                            style = LineStyle.Solid,
                            color = Colors.Black
                        )
                        .fontFamily(FONT_FAMILY2)
                        .fontSize(16.px)
                        .onClick {
                            useMilesInterval = !useMilesInterval
                        }
                        .toAttrs{
                            if (useMilesInterval) attr("checked", "")
                        }
                )

                H3(
                    attrs = Modifier
                        .color(if (!useMilesInterval) Colors.LightGray else Colors.Black)
                        .fontFamily(FONT_FAMILY)
                        .fontSize(1.cssRem)
                        .fontWeight(FontWeight.Medium)
                        .toAttrs()
                ) {
                    Text("Miles Due Interval:")
                }
            }

            Input(
                type = InputType.Number,
                attrs = Modifier
                    .id(InputIDs.MaintenanceSchedules.scheduleIntervalMiles)
                    .disabled(!useMilesInterval)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 2.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .toAttrs {
                        attr("placeholder", "Interval Miles Amount")
                        attr("value", newMaintSched.intervalMiles.toString()) // Set value from DTO
                    }
            )


            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Input(
                    type = InputType.Checkbox,
                    attrs = Modifier
                        .height(15.px)
                        .width(15.px)
                        .margin(
                            right = 12.px,
                        )
                        .padding(leftRight = 20.px)
                        .backgroundColor(Theme.LightGray.rgb)
                        .borderRadius(r = 4.px)
                        .border(
                            width = 1.px,
                            style = LineStyle.Solid,
                            color = Colors.Black
                        )
                        .fontFamily(FONT_FAMILY2)
                        .fontSize(16.px)
                        .onClick {
                            useDaysInterval = !useDaysInterval
                        }
                        .toAttrs{
                            if (useDaysInterval) attr("checked", "")
                        }
                )

                H3(
                    attrs = Modifier
                        .color(if (!useDaysInterval) Colors.LightGray else Colors.Black)
                        .fontFamily(FONT_FAMILY)
                        .fontSize(1.cssRem)
                        .fontWeight(FontWeight.Medium)
                        .toAttrs()
                ) {
                    Text("Interval in Days:")
                }
            }

            Input(
                type = InputType.Number,
                attrs = Modifier
                    .id(InputIDs.MaintenanceSchedules.scheduleIntervalDays)
                    .disabled(!useDaysInterval)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 2.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .toAttrs {
                        attr("placeholder", "Interval Days Amount")
                        attr("value", newMaintSched.intervalDays.toString()) // Set value from DTO
                    }
            )

            H3(
                attrs = Modifier
                    .fillMaxWidth()
                    .textAlign(TextAlign.Start)
                    .color(if (!useDaysInterval) Colors.LightGray else Colors.Black)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(1.cssRem)
                    .fontWeight(FontWeight.Medium)
                    .toAttrs()
            ) {
                Text("Start Date:")
            }

            Input(
                type = InputType.Date,
                attrs = Modifier
                    .id(InputIDs.MaintenanceSchedules.scheduleStartDate)
                    .disabled(!useDaysInterval)
                    .fillMaxWidth()
                    .height(54.px)
                    .margin(topBottom = 12.px)
                    .padding(leftRight = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(r = 4.px)
                    .border(
                        width = 2.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .toAttrs {
                        attr(
                            attr = "value",
                            value = startDateValue
                        )
                    }
            )

            H3(
                attrs = Modifier
                    .fillMaxWidth()
                    .textAlign(TextAlign.Start)
                    .color(Colors.Black)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(1.cssRem)
                    .fontWeight(FontWeight.Medium)
                    .toAttrs()
            ) {
                Text("Description")
            }

            TextArea(
                attrs = Modifier
                    .id(InputIDs.MaintenanceSchedules.scheduleDescription)
                    .fillMaxWidth()
                    .height(175.px)
                    .maxHeight(400.px)
                    .margin(top = 8.px)
                    .padding(all = 10.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(4.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .border(
                        width = 2.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .resize(Resize.None)
                    .toAttrs{
                        onInput { event ->
                            newMaintSched.description = event.value
                        }
                    }
            )

            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            ) {

                SpanText(
                    text = "Created: ${newMaintSched.createdAt?.let { formatDate(it) } ?: "NA"}",
                    modifier = Modifier
                        .fontSize(.75.cssRem)
                        .fontFamily(FONT_FAMILY2)
                )
            }

            H3(
                attrs = Modifier
                    .color(Colors.Black)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(0.75.cssRem)
                    .fontWeight(FontWeight.Medium)
                    .textAlign(TextAlign.Center)
                    .margin(topBottom = 4.px)
                    .toAttrs()
            ) {
                if (toUpdateMaintSched != null) {
                    Text("This schedule update will apply on newly generated items.")
                } else {
                    Text(" ")
                }
            }

            SpanText(
                modifier = Modifier
                    .width(350.px)
                    .margin(top = 1.cssRem)
                    .fontFamily(FONT_FAMILY2)
                    .color(Colors.Black)
                    .textAlign(TextAlign.Center),
                text = errorText
            )

            SubmitButton(
                text = "SUBMIT",
                onClick = {
                    errorText = " "
                    val name = (document.getElementById(InputIDs.MaintenanceSchedules.scheduleName) as HTMLInputElement).value

                    val intervalMilesInput = if (useMilesInterval) {
                        (document.getElementById(InputIDs.MaintenanceSchedules.scheduleIntervalMiles) as HTMLInputElement).value.toIntOrNull()
                    } else {
                        null
                    }

                    val intervalDaysInput = if (useDaysInterval) {
                        (document.getElementById(InputIDs.MaintenanceSchedules.scheduleIntervalDays) as HTMLInputElement).value.toIntOrNull()
                    } else {
                        null
                    }

                    val startDateInput = try {
                            val date = LocalDate.parse((document.getElementById(InputIDs.MaintenanceSchedules.scheduleStartDate) as HTMLInputElement).value)
                            LocalDateTime(date, LocalTime(0, 0))
                        } catch (e: Exception) {
                            console.log("Oops! Proper date please!")
                            null
                    }

                    val description = (document.getElementById(InputIDs.MaintenanceSchedules.scheduleDescription) as HTMLTextAreaElement).value

                    if (
                        name.isNotEmpty() &&
                        name.isNotBlank() &&
                        startDateInput != null
                    ) {
                        val milesValid = intervalMilesInput != null && intervalMilesInput > 0
                        val daysValid = intervalDaysInput != null && intervalDaysInput > 0

                        if (milesValid || daysValid) {
                            newMaintSched = newMaintSched.copy(intervalMiles = intervalMilesInput)
                            newMaintSched = newMaintSched.copy(intervalDays = intervalDaysInput)

                            newMaintSched = newMaintSched.copy(
                                name = name,
                                startDate = startDateInput.toString(),
                                description = description
                            )

                            showConfirmModal = true
                        } else {
                            errorText = "Enter a valid interval in miles, days, or both!"
                        }
                    } else {
                        errorText = "Please fill out all required fields!"
                    }

                }
            )

            if (showConfirmModal) {
                ConfirmModal(
                    actionText = if (toUpdateMaintSched != null) "Update Schedule" else "Submit Schedule",
                    subText = if (toUpdateMaintSched != null) "This schedule update will apply on newly generated items" else "",
                    onConfirm = {
                        errorText = "Submitted!"
                        onSubmit(newMaintSched)
                        showConfirmModal = false
                    },
                    onDismiss = {
                        showConfirmModal = false
                    }
                )
            }
        }

        Box(
            modifier = Modifier
                .fillMaxSize()
                .backgroundColor(Theme.DarkerGray.rgb)
                .position(Position.Fixed)
                .padding(top = 5.cssRem)
                .onClick {
                    onDismiss()
                }
                .zIndex(19),
            contentAlignment = Alignment.TopCenter
        )
    }
}